import React, { FC } from 'react';

import PublicLabel from 'components/labels/PublicLabel';
import DefaultLabel from 'components/labels/DefaultLabel';

import { useMe } from 'graphql/hooks/user';

const PublicLabelCell: FC<CellProps<WithPublic>> = ({ data }) => {
  const { isAdmin } = useMe();

  return (
    <div className="labels">
      {isAdmin && data?.isDefault ? <DefaultLabel /> : null}
      {data?.isPublic ? <PublicLabel /> : null}
    </div>
  );
};

export default PublicLabelCell;
